import { ISelectOption } from '~/src/dash/components/dropdowns/common';

export const convertSingleNumberIntoArray = (value: number) => [value];
export const convertSetIntoSingleNumber = (value: Set<number>) => Array.from(value)[0];

export const convertSetIntoString = (value: Set<number | string>) => {
  if (value && value.size > 0) {
    return Array.from(value).join(',');
  } else {
    return '';
  }
};

export const convertStringIntoArray = (value: string) => {
  if (value) {
    return value.split(',');
  } else {
    return [];
  }
};

// use only if 1 = false, 2 = true
export const convertEBoolIntoBoolean = (value: number) => {
  return value === 2;
};

// use only if 1 = false, 2 = true
export const convertBooleanIntoEBool = (value: boolean) => {
  if (value) {
    return 2;
  }
  return 1;
};

export const validateName = (name: string) => {
  const sanitizedName = name.replace(/("|')/g, '');
  const sanitizedNameLength = sanitizedName.length;
  let nameError = '';
  switch (true) {
    case name.length > sanitizedNameLength:
      nameError = 'Name contains invalid characters.';
      break;
    case !sanitizedName:
      nameError = 'Name field is empty.';
      break;
    case sanitizedNameLength < 3:
    case sanitizedNameLength > 99:
      nameError = 'Name must be between 3 - 99 characters.';
      break;
    default:
      break;
  }
  return { sanitizedName, nameError };
};

export const removeEmojiPrefixFromLabel = (option: ISelectOption): string => {
  const spaceIndex = option.label.indexOf(' ');
  return option.label.substring(spaceIndex > 0 ? spaceIndex : 0).trim();
};
